import { Component, OnInit, Input, Output, EventEmitter, OnChanges } from '@angular/core';
import { Router } from '@angular/router';
import { VariablesZonaCompartida } from '../../services/VariablesZonaCompartida';
import { GlobalService } from '../../global.service';

@Component({
  selector: 'app-tarjeta-registro',
  templateUrl: './tarjeta-registro.component.html',
  styleUrls: ['./tarjeta-registro.component.scss']
})
export class TarjetaRegistroComponent implements OnInit, OnChanges {

  @Input() objeto: any[] = [];
  @Output() detalle: EventEmitter<any>;
  paginas: number[] = [];
  inicio: number;
  fin: number;
  public p: any;

  constructor(
    private router: Router,
    private global: GlobalService
  ) {
    this.inicio = 0;
    this.fin = 6;
    this.detalle = new EventEmitter();
  }

  ngOnInit() {
  }

  ngOnChanges(): void {
    this.paginador();
  }

  cambiarPagina(valor: any) {
    switch (valor) {
      case 'a':
        this.inicio = 0;
        this.fin = 6;
        break;

      case 's':
        const mod = this.objeto.length % 6;

        if (mod === 0) {
          this.inicio = this.objeto.length - 6;
        } else {
          this.inicio = this.objeto.length - mod;
        }
        this.fin = this.objeto.length;
        break;

      default:
        this.inicio = (valor - 1) * 6;
        this.fin = valor * 6;
        break;

    }
  }

  paginador() {
    this.paginas = [];
    if (this.objeto) {
      const numeroPaginas = (this.objeto.length / 6);

      for (let i = 0; i < numeroPaginas; i++) {
        const element = numeroPaginas[i];
        this.paginas.push(element);
      }
    }
  }

  /**
   * Método que direcciona a al editar Tarjetas
   */
  editarTarjetas(event) {
    this.global.zonaCompartida[VariablesZonaCompartida.TIPO_GENRACION] = event;
    this.router.navigate(['/main/editar-codigos-reutilizable']);
  }

  /**
   * Método que direcciona a al editar Stickers
   */
  editarStickers() {
      this.router.navigate(['/main/editar-codigos-reutilizable']);
  }

  irADetalle(obj: any, tipo: string) {
    this.detalle.emit({ objeto: obj, tipo, idEvent: 'registroActivoFijo' });
  }
}
